import { Typography } from '@mui/material';

import * as Styled from './FAQItem.styles';

const FAQItem = ({ item, index, isOpen, onToggle }) => {
  const number = String(index + 1).padStart(2, '0');

  return (
    <Styled.Item type="button" onClick={onToggle} aria-expanded={isOpen}>
      <Styled.Row>
        <Styled.Index
          variant="h4"
          component="span"
          className="faq-index"
          isOpen={isOpen}
        >
          {number} /
        </Styled.Index>

        <Styled.Question
          variant="h4"
          component="span"
          className="faq-question"
          isOpen={isOpen}
        >
          {item.question}
        </Styled.Question>

        <Styled.Arrow
          src={
            isOpen ? '/icons/arrow-down-right.svg' : '/icons/arrow-up-right.svg'
          }
          alt=""
          aria-hidden
        />
      </Styled.Row>

      <Styled.AnswerCollapse in={isOpen} timeout={350}>
        <Styled.Answer>
          {item.answer.map((paragraph, paragraphIndex) => (
            <Typography variant="body16" key={paragraphIndex}>
              {paragraph}
            </Typography>
          ))}
        </Styled.Answer>
      </Styled.AnswerCollapse>
    </Styled.Item>
  );
};

export default FAQItem;
